import { Component, ElementRef, Input } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { ModalController } from '@ionic/angular';
import { ToastService } from '../../../_core/services/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-add-or-invite-modal',
  templateUrl: './add-or-invite-modal.component.html',
  styleUrls: ['./add-or-invite-modal.component.scss'],
  standalone: false // same as ConfirmEmailComponent
})
export class AddOrInvitePlayerModal {
  @Input() inviteLink = '';
  @Input() view: 'sheet' | 'link' | 'email' | 'phone' = 'sheet';
  canShare: boolean;
  title: string = '';

  invitationOptions = [
    // {
    //   id: 'email',
    //   icon: 'at-outline',
    //   text: 'Email',
    // },
    // {
    //   id: 'phone',
    //   icon: 'phone-portrait-outline',
    //   text: 'Phone Number',
    // },
    {
      id: 'link',
      icon: 'link-outline',
      text: 'Invite Link',
    },
    {
      id: 'players',
      icon: 'people-outline',
      text: 'My Players',
    }
  ];

  constructor(
    private modalCtrl: ModalController,
    private toastService: ToastService,
    private el: ElementRef,
    private translateService: TranslateService
  ) {
    this.canShare = Capacitor.isNativePlatform();
    this.title = this.translateService.instant('Add Player');
  }

  copy() {
    this.toastService.presentToast(this.translateService.instant('Link copied to clipboard!'));
    navigator.clipboard.writeText(this.inviteLink);
  }

  async share() {
    if (navigator.share) {
      await navigator.share({ url: this.inviteLink });
    }
  }

  close() {
    this.modalCtrl.dismiss();
  }

  selectOption(optionId: string) {
    switch (optionId) {
      case 'email':
        this.view = 'email';
        break;
      case 'phone':
        this.view = 'phone';
        break;
      case 'link':
        this.title = this.translateService.instant('Invite');
        this.view = 'link';
        const modalEl = this.el.nativeElement.closest('ion-modal');
        if (modalEl) {
          const modalWrapper = modalEl.shadowRoot?.querySelector('.modal-wrapper') as HTMLElement;
          if (modalWrapper) {
            modalWrapper.style.height = '120%'; // ✅ Set your custom height here
          }
        }
        break;
      case 'players':
        this.modalCtrl.dismiss({ addMyPlayer: true });
        break;
    }
  }
}
